export default __webpack_public_path__ + "static/Residential-Interior-Demolition-c8394459e33685d49fbbe228f32dfe52.jpg";